export function DragHandleIcon() {
  return (
    <svg width="33" height="4" viewBox="0 0 33 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="32" height="4" rx="2" fill="#D1D5DB" />
    </svg>
  );
}
